var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ 'form-inline': _vm.inline }, { 'form-group': _vm.group }]},[_c('button',{staticClass:"btn",class:[_vm.btnClass, { 'btn-loading': _vm.loading }],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.onclick}},[_vm._v(" "+_vm._s(_vm.directlabel || _vm.$t(_vm.label))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }